import React, {useEffect, useState} from "react";
import {FaExclamationTriangle} from "react-icons/fa";
import JobComplaintModal from "./JobComplaintModal";
import {markJobComplained, subscribeComplaintSummary} from "./complaintSummaryStore";

export default function JobComplaintButton({job, label = false}) {
    const [show, setShow] = useState(false);
    const [hasComplaint, setHasComplaint] = useState(Boolean(job.has_complaint));
    useEffect(() => subscribeComplaintSummary(job.cos_job_id, setHasComplaint), [job.cos_job_id]);

    return <>
        <button
            type="button"
            className={label ? "btn btn-outline-danger btn-sm" : "btn btn-link p-0"}
            title={hasComplaint ? "Existing Job complaint" : "Add Job complaint"}
            aria-label={`${hasComplaint ? "Existing complaint" : "Add complaint"} for job ${job.cos_job_id}`}
            onClick={event => {
                event.stopPropagation();
                setShow(true);
            }}
            style={label ? undefined : {marginLeft: 10, display: "inline-flex", alignItems: "center", justifyContent: "center", minWidth: 22, height: 22, border: 0, lineHeight: 1, color: hasComplaint ? "#dc3545" : "#6c757d"}}
        >
            <FaExclamationTriangle size={label ? 16 : 20}/>{label ? hasComplaint ? " Complaint filed" : " Complaint" : hasComplaint ? <span style={{fontSize: 10, fontWeight: 700, marginLeft: 2}}>Filed</span> : null}
        </button>
        {show ? <JobComplaintModal
            job={job}
            show
            onClose={() => setShow(false)}
            onSaved={() => markJobComplained(job.cos_job_id)}
        /> : null}
    </>;
}
